// Industries Content API
// Comprehensive industry-specific landing page content

// Import industry icons and images
import sIcon1 from '../images/industrie/img01.png'
import sIcon2 from '../images/industrie/img02.png'
import sIcon3 from '../images/industrie/img03.png'
import sIcon4 from '../images/industrie/img04.png'
import sIcon5 from '../images/industrie/img05.png'
import sIcon6 from '../images/industrie/img06.png'
import sIcon7 from '../images/industrie/img07.png'
import sIcon8 from '../images/industrie/img08.png'
import sIcon9 from '../images/industrie/img09.png'
import sIcon10 from '../images/industrie/img10.png'

// Industry data with detailed content for landing pages
const Industries = [
    {
        id: '1',
        title: 'SaaS',
        slug: 'saas',
        icon: sIcon1,
        tagline: 'Enterprise SaaS Development Company | Cloud Software Solutions 2026',
        hero: {
            title: 'Custom SaaS Application Development Services | Build Scalable Cloud Software',
            subtitle: 'Partner with expert SaaS developers to build cloud-native software-as-a-service platforms with multi-tenant architecture, subscription billing, enterprise security, and 99.9% uptime. Trusted by 100+ SaaS companies worldwide.',
            highlights: [
                'Multi-Tenant SaaS Architecture with Data Isolation',
                'Automated Subscription Billing & Revenue Management',
                'RESTful API Development with GraphQL Support',
                'Real-Time Analytics Dashboards & Business Intelligence'
            ]
        },
        overview: {
            title: 'Why Choose Our SaaS Development Company?',
            description: 'We specialize in building enterprise-grade SaaS applications that scale effortlessly from MVP to millions of users. Our full-stack SaaS development services include cloud-native architecture, microservices, automated CI/CD pipelines, robust security frameworks, and seamless third-party integrations. Whether you\'re launching a new SaaS product or modernizing legacy software, our team delivers production-ready solutions built with React, Node.js, AWS/Azure, and best practices for SaaS scalability and performance.',
            stats: [
                { value: '99.9%', label: 'SaaS Uptime SLA' },
                { value: '50M+', label: 'Daily API Calls' },
                { value: '10x', label: 'Faster Market Launch' }
            ]
        },
        services: [
            {
                title: 'Cloud-Native SaaS Architecture',
                description: 'Build scalable SaaS platforms with microservices architecture, Docker containerization, Kubernetes orchestration, and serverless functions for automatic scaling and cost-effective cloud infrastructure.',
                icon: 'cloud'
            },
            {
                title: 'Subscription & Billing Management',
                description: 'Implement comprehensive SaaS billing systems with Stripe/PayPal integration, usage-based pricing, automated invoicing, recurring subscriptions, and subscription analytics dashboards.',
                icon: 'credit-card'
            },
            {
                title: 'Multi-Tenant SaaS Solutions',
                description: 'Develop secure multi-tenant SaaS applications with complete data isolation, tenant-level customization, role-based access control (RBAC), and efficient resource allocation per customer.',
                icon: 'database'
            },
            {
                title: 'SaaS API Development',
                description: 'Create robust RESTful and GraphQL APIs with comprehensive documentation, OAuth 2.0 authentication, rate limiting, API versioning, webhook integrations, and developer-friendly SDKs.',
                icon: 'code'
            }
        ],
        technologies: {
            title: 'Modern SaaS Technology Stack for 2026',
            items: [
                'React/Next.js 14 for responsive SaaS frontends',
                'Node.js/Python/Go microservices backend architecture',
                'PostgreSQL/MongoDB for multi-tenant data persistence',
                'Redis for real-time caching and session management',
                'AWS/Azure/Google Cloud Platform infrastructure',
                'Docker/Kubernetes for container orchestration',
                'Stripe/PayPal/Chargebee payment integration',
                'Auth0/AWS Cognito authentication & authorization'
            ]
        },
        caseStudy: {
            title: 'Success Story: Enterprise Project Management SaaS Platform',
            description: 'Delivered a complete cloud-based project management SaaS platform serving 10,000+ active users across 50+ countries with real-time collaboration, automated workflow automation, advanced reporting analytics, and 99.98% uptime. Integrated with Slack, Microsoft Teams, and Google Workspace for seamless team productivity.',
            results: [
                '3-month MVP to production launch',
                '150% user growth in first 6 months',
                '40% reduction in customer operational costs'
            ]
        },
        cta: {
            title: 'Ready to Build Your SaaS Platform in 2026?',
            subtitle: 'Schedule a free consultation with our SaaS development experts to discuss your vision and create a scalable cloud software solution that drives recurring revenue and customer success.',
            buttonText: 'Get Free SaaS Consultation'
        }
    },
    {
        id: '2',
        title: 'Legal Tech',
        slug: 'legal',
        icon: sIcon2,
        tagline: 'Legal Practice Management Software Development | LegalTech Solutions 2026',
        hero: {
            title: 'Custom Legal Software Development Services | Case Management & Document Automation',
            subtitle: 'Transform your law firm with enterprise legal technology solutions including case management systems, AI-powered document automation, secure client portals, legal research AI, and practice management software. GDPR/HIPAA compliant solutions trusted by 200+ law firms.',
            highlights: [
                'Cloud-Based Case Management Software with Deadline Tracking',
                'AI-Powered Legal Document Automation & Contract Review',
                'Secure Client Portal Development with E-Signatures',
                'GPT-Powered Legal Research & Precedent Analysis Tools'
            ]
        },
        overview: {
            title: 'Why Choose Our Legal Technology Development Company?',
            description: 'We specialize in building secure, compliant legal software solutions that transform how law firms manage cases, serve clients, and handle administrative workflows. Our custom legaltech development services include practice management systems, document automation platforms, client relationship management (CRM), billing software, and AI-powered legal research tools built with enterprise security, end-to-end encryption, and full regulatory compliance for law firms of all sizes.',
            stats: [
                { value: '70%', label: 'Reduction in Administrative Time' },
                { value: '100%', label: 'GDPR/HIPAA Compliant' },
                { value: '5x', label: 'Faster Document Processing' }
            ]
        },
        services: [
            {
                title: 'Legal Case Management Software Development',
                description: 'Build comprehensive cloud-based case management platforms with deadline tracking, court date calendars, automated client communications, conflict checking, matter management, time tracking, and secure document storage with version control for law firms.',
                icon: 'gavel'
            },
            {
                title: 'Legal Document Automation Systems',
                description: 'Develop AI-powered document generation platforms with intelligent templates, automated contract review using NLP, clause extraction, risk analysis, DocuSign/Adobe Sign integration, and automated legal brief creation reducing document prep time by 80%.',
                icon: 'file-alt'
            },
            {
                title: 'Client Portal & Communication Platforms',
                description: 'Create secure attorney-client portals with encrypted messaging, document sharing, billing transparency, invoice payments, case status updates, appointment scheduling, and multilingual support for enhanced client service.',
                icon: 'users-cog'
            },
            {
                title: 'AI Legal Research & Precedent Analysis',
                description: 'Build GPT-powered legal research assistants with case law analysis, precedent matching, jurisdiction-specific research, automated citation checking, legal brief summarization, and integration with Westlaw/LexisNexis databases.',
                icon: 'brain'
            }
        ],
        technologies: {
            title: 'Enterprise Legal Technology Stack for 2026',
            items: [
                'AES-256 end-to-end encryption for attorney-client privilege',
                'GDPR, HIPAA & SOC 2 Type II compliance frameworks',
                'Microsoft Azure/AWS GovCloud secure hosting',
                'DocuSign/Adobe Sign e-signature API integration',
                'LexisNexis/Westlaw research API connectivity',
                'OpenAI GPT-4 for legal document analysis',
                'Okta/Auth0 Single Sign-On (SSO) authentication',
                'Penetration testing & annual security audits'
            ]
        },
        caseStudy: {
            title: 'Success Story: Immigration Law Firm Digital Transformation',
            description: 'Delivered a complete legal practice management platform for a 20-attorney immigration law firm handling 800+ active cases annually with automated USCIS form generation, multilingual client portal (English/Spanish/Mandarin), case status tracking, and integrated billing reducing administrative overhead by 65%.',
            results: [
                '65% reduction in administrative time',
                '95% client satisfaction rating (NPS 72)',
                'Zero security breaches in 3+ years'
            ]
        },
        cta: {
            title: 'Modernize Your Law Firm with Custom LegalTech in 2026',
            subtitle: 'Schedule a free consultation with our legal software development experts to build secure, GDPR-compliant solutions tailored to your practice areas and firm size.',
            buttonText: 'Get Free LegalTech Consultation'
        }
    },
    {
        id: '3',
        title: 'Real Estate Tech',
        slug: 'real-estate',
        icon: sIcon3,
        tagline: 'PropTech Software Development | Property Management Solutions 2026',
        hero: {
            title: 'Custom Real Estate Software Development | PropTech Solutions & Property Management Platforms',
            subtitle: 'Transform your real estate business with enterprise property management software, 3D virtual tour technology, MLS-integrated platforms, real estate CRM systems, and online property marketplaces. Trusted by 150+ property management companies and real estate agencies.',
            highlights: [
                'Cloud Property Management Software with Online Rent Collection',
                '360° Virtual Tours, 3D Walkthroughs & AR Property Visualization',
                'Real Estate CRM with Lead Management & Transaction Tracking',
                'Custom Property Marketplace Development with IDX/MLS Integration'
            ]
        },
        overview: {
            title: 'Why Choose Our PropTech Development Company?',
            description: 'We create cutting-edge real estate technology solutions that streamline property management operations, accelerate leasing cycles, and enhance tenant experiences through digital transformation. Our PropTech development services include comprehensive property management systems, tenant portals, maintenance workflow automation, online rent payment processing, CRM platforms, virtual tour solutions, and custom real estate marketplace applications built with modern cloud infrastructure, mobile-first design, and seamless third-party integrations.',
            stats: [
                { value: '50%', label: 'Faster Property Leasing Cycles' },
                { value: '85%', label: 'Tenant Satisfaction Rating' },
                { value: '30%', label: 'Operational Cost Reduction' }
            ]
        },
        services: [
            {
                title: 'Property Management Software Development',
                description: 'Build comprehensive cloud-based property management platforms with automated rent collection, ACH/credit card payments, lease management, maintenance request tracking, tenant communication portals, financial reporting, vacancy management, and owner portal access for residential and commercial properties.',
                icon: 'building'
            },
            {
                title: 'Virtual Tour & 3D Visualization Technology',
                description: 'Develop immersive 360° virtual property tours, interactive 3D floor plans, augmented reality (AR) property previews, drone photography integration, and WebGL-based walkthroughs that increase property engagement by 200% and reduce site visit requirements.',
                icon: 'cube'
            },
            {
                title: 'Real Estate CRM & Lead Management',
                description: 'Create intelligent CRM systems with automated lead capture, email/SMS drip campaigns, transaction pipeline management, client communication tracking, referral management, commission calculations, and integration with Zillow, Realtor.com, and social media lead sources.',
                icon: 'users-cog'
            },
            {
                title: 'Property Marketplace Platform Development',
                description: 'Build custom real estate marketplaces with advanced property search filters, Google Maps/Mapbox integration, saved searches, property comparison tools, mortgage calculators, MLS/IDX data feeds, secure messaging, and integrated booking/scheduling for viewings.',
                icon: 'project-diagram'
            }
        ],
        technologies: {
            title: 'Modern PropTech Development Stack for 2026',
            items: [
                'React/Next.js 14 for responsive web applications',
                'React Native/Flutter for iOS & Android mobile apps',
                'Three.js/WebGL for 3D property visualizations',
                'Google Maps API/Mapbox for interactive mapping',
                'Stripe/PayPal for online rent & payment processing',
                'Twilio for SMS/email automation & notifications',
                'AI-powered property matching algorithms',
                'IoT smart building integrations (locks, thermostats, sensors)'
            ]
        },
        caseStudy: {
            title: 'Success Story: Multi-Family Residential Property Management Platform',
            description: 'Developed an enterprise property management system managing 5,000+ residential units across 50 properties with automated rent collection, maintenance workflows, tenant mobile app, lease renewals, and comprehensive financial reporting reducing operational overhead by 35%.',
            results: [
                '90% online rent collection adoption',
                '45% faster maintenance resolution time',
                '$2M annual operational cost savings'
            ]
        },
        cta: {
            title: 'Transform Your Real Estate Business with Custom PropTech in 2026',
            subtitle: 'Schedule a free consultation to build the property management or PropTech solution that differentiates your business and drives growth.',
            buttonText: 'Get Free PropTech Consultation'
        }
    },
    {
        id: '4',
        title: 'Insurance Tech',
        slug: 'insurance',
        icon: sIcon4,
        tagline: 'InsurTech Software Development | Insurance Technology Solutions 2026',
        hero: {
            title: 'Custom Insurance Software Development | InsurTech Solutions & Digital Transformation',
            subtitle: 'Modernize insurance operations with AI-powered claims management systems, policy administration platforms, automated underwriting software, risk assessment tools, and customer self-service portals. GDPR/SOC 2 compliant solutions trusted by 80+ insurance carriers, MGAs, and insurance agencies.',
            highlights: [
                'AI-Powered Claims Processing Automation with Fraud Detection',
                'Cloud-Based Policy Administration & Automated Underwriting',
                'Machine Learning Risk Assessment & Predictive Analytics',
                'Mobile-First Customer Self-Service Insurance Portals'
            ]
        },
        overview: {
            title: 'Why Choose Our InsurTech Development Company?',
            description: 'We transform traditional insurance operations with modern digital solutions that accelerate claims processing, streamline policy management, and deliver superior customer experiences. Our InsurTech development services include comprehensive insurance software solutions for claims management automation, policy administration systems, agent/broker portals, underwriting workflow automation, actuarial systems, reinsurance platforms, and customer mobile applications built with enterprise security, regulatory compliance (GDPR/HIPAA/SOC 2), and seamless legacy system integration capabilities.',
            stats: [
                { value: '65%', label: 'Faster Claims Settlement Time' },
                { value: '80%', label: 'Customer Self-Service Adoption' },
                { value: '40%', label: 'Operational Cost Reduction' }
            ]
        },
        services: [
            {
                title: 'Claims Management System Development',
                description: 'Build intelligent claims processing platforms with automated FNOL (First Notice of Loss) intake, AI-powered damage assessment using computer vision, fraud detection algorithms, automated adjuster assignment, digital disbursement, real-time status tracking, and customer mobile apps for photo/document submission.',
                icon: 'clipboard-list'
            },
            {
                title: 'Policy Administration Systems (PAS)',
                description: 'Develop modern policy administration platforms with quote-to-bind automation, policy issuance, endorsement processing, renewal automation, billing & commission management, agent portals, and integration with rating engines and third-party data providers (ISO, Verisk, LexisNexis).',
                icon: 'file-contract'
            },
            {
                title: 'AI Risk Assessment & Underwriting',
                description: 'Create machine learning models for automated risk scoring, predictive analytics for loss forecasting, dynamic pricing optimization, telematics data analysis for auto insurance, IoT sensor integration for property insurance, and automated underwriting decision engines that reduce processing time by 70%.',
                icon: 'calculator'
            },
            {
                title: 'Customer & Agent Portal Development',
                description: 'Build self-service insurance portals with policy management, online quote requests, digital insurance card access, claims filing & tracking, document upload, payment processing, chat support, and agent/broker dashboards with commission tracking and multi-carrier integration.',
                icon: 'mobile-alt'
            }
        ],
        technologies: {
            title: 'Enterprise InsurTech Development Stack for 2026',
            items: [
                'Python/TensorFlow for machine learning risk models',
                'React/Angular for modern insurance web applications',
                'React Native for iOS & Android insurance mobile apps',
                'Blockchain for claims verification & smart contracts',
                'OCR & NLP for automated document processing',
                'Legacy system API integration (mainframe/AS400)',
                'AWS/Azure cloud infrastructure with SOC 2 compliance',
                'AES-256 encryption & PCI DSS payment security'
            ]
        },
        caseStudy: {
            title: 'Success Story: Auto Insurance Claims Processing Platform',
            description: 'Delivered an AI-powered auto insurance claims system processing 50,000+ annual claims with computer vision damage assessment, automated repair shop network coordination, digital payment disbursement, and mobile-first customer experience reducing average claim settlement from 10 days to 24 hours.',
            results: [
                '75% reduction in claims processing time',
                '35% operational cost savings ($2.5M annually)',
                '92% customer satisfaction rating (NPS 68)'
            ]
        },
        cta: {
            title: 'Accelerate Your Insurance Digital Transformation in 2026',
            subtitle: 'Schedule a free consultation with our InsurTech development experts to build intelligent insurance systems that reduce costs, speed up claims, and enhance customer experiences.',
            buttonText: 'Get Free InsurTech Consultation'
        }
    },
    {
        id: '5',
        title: 'Crypto & Blockchain',
        slug: 'crypto',
        icon: sIcon5,
        tagline: 'Blockchain Development Company | Web3 & DeFi Solutions 2026',
        hero: {
            title: 'Custom Blockchain Development Services | Smart Contracts, DeFi & Web3 Applications',
            subtitle: 'Partner with expert blockchain developers to build secure decentralized applications (dApps), smart contracts, DeFi protocols, NFT marketplaces, cryptocurrency exchanges, and Web3 platforms on Ethereum, Solana, Polygon, and BSC. Trusted by 50+ Web3 startups and crypto companies.',
            highlights: [
                'Solidity/Rust Smart Contract Development & Security Audits',
                'DeFi Protocol Development: DEX, Lending, Staking Platforms',
                'NFT Marketplace Development with IPFS & Royalty Systems',
                'Cryptocurrency Exchange & Wallet Development (KYC/AML)'
            ]
        },
        overview: {
            title: 'Why Choose Our Blockchain Development Company?',
            description: 'We are blockchain development pioneers building secure, scalable decentralized applications across multiple blockchain networks. Our Web3 development services include smart contract programming, DeFi protocol architecture, NFT platform development, cryptocurrency exchange solutions, blockchain integration for enterprises, tokenomics design, DAO governance systems, and comprehensive security audits. Whether you\'re launching a DeFi protocol, NFT marketplace, or enterprise blockchain solution, our team delivers production-ready Web3 applications built with Solidity, Rust, Hardhat, and industry best practices for security and gas optimization.',
            stats: [
                { value: '$100M+', label: 'Total Value Secured (TVL)' },
                { value: '500K+', label: 'On-Chain Transactions Processed' },
                { value: '0', label: 'Smart Contract Security Breaches' }
            ]
        },
        services: [
            {
                title: 'Smart Contract Development & Auditing',
                description: 'Build secure smart contracts in Solidity (Ethereum/Polygon) and Rust (Solana) with comprehensive security audits, formal verification, gas optimization, upgradeable contract patterns (proxy/diamond), automated testing suites, and integration with Chainlink oracles for real-world data.',
                icon: 'file-code'
            },
            {
                title: 'DeFi Protocol Development',
                description: 'Create decentralized finance platforms including automated market makers (AMM DEX), lending/borrowing protocols, yield farming aggregators, liquidity mining platforms, staking systems, algorithmic stablecoins, and cross-chain bridges with multi-signature governance and time-locked upgrades.',
                icon: 'exchange-alt'
            },
            {
                title: 'NFT Marketplace & Platform Development',
                description: 'Build comprehensive NFT ecosystems with ERC-721/ERC-1155 smart contracts, minting platforms (lazy minting supported), primary/secondary marketplaces, auction systems, royalty distribution, IPFS/Arweave decentralized storage, metadata management, and wallet integration (MetaMask, WalletConnect, Coinbase Wallet).',
                icon: 'certificate'
            },
            {
                title: 'Crypto Exchange & Wallet Development',
                description: 'Develop secure cryptocurrency exchanges (CEX/DEX), non-custodial wallet applications, multi-signature wallets, hardware wallet integration, KYC/AML compliance systems, order matching engines, liquidity aggregation, fiat on/off ramps, and real-time trading dashboards with TradingView charts.',
                icon: 'wallet'
            }
        ],
        technologies: {
            title: 'Advanced Web3 & Blockchain Technology Stack 2026',
            items: [
                'Solidity for Ethereum/Polygon/BSC smart contracts',
                'Rust for Solana programs & high-performance chains',
                'Hardhat/Foundry for development & testing frameworks',
                'Web3.js/Ethers.js/Wagmi for blockchain integration',
                'IPFS/Arweave for decentralized file storage',
                'The Graph protocol for blockchain data indexing',
                'MetaMask/WalletConnect/Coinbase Wallet integration',
                'OpenZeppelin contracts & Trail of Bits security audits'
            ]
        },
        caseStudy: {
            title: 'Success Story: Multi-Chain DeFi Staking & Yield Platform',
            description: 'Launched a decentralized staking platform with $25M+ Total Value Locked (TVL) supporting Ethereum, Polygon, and Binance Smart Chain with automated yield optimization, liquidity mining rewards, governance token distribution, and comprehensive security audits by CertiK resulting in zero smart contract vulnerabilities across 500,000+ transactions.',
            results: [
                '$25M+ Total Value Locked (TVL)',
                '8,500+ active unique wallet addresses',
                'Zero smart contract exploits (100% secure)'
            ]
        },
        cta: {
            title: 'Launch Your Web3 & Blockchain Project in 2026',
            subtitle: 'Schedule a free consultation with experienced Web3 developers to build secure, scalable blockchain solutions including DeFi protocols, NFT platforms, and decentralized applications.',
            buttonText: 'Get Free Blockchain Consultation'
        }
    },
    {
        id: '6',
        title: 'Private Equity',
        slug: 'private-equity',
        icon: sIcon6,
        tagline: 'Private Equity Software Development | Fund Management Solutions 2026',
        hero: {
            title: 'Custom Private Equity Software Development | Fund Management & Portfolio Tracking',
            subtitle: 'Transform PE operations with enterprise deal flow management systems, portfolio monitoring platforms, investor reporting portals, fund administration software, and data analytics solutions. SOC 2 Type II compliant platforms trusted by 40+ private equity firms, venture capital funds, and family offices.',
            highlights: [
                'Deal Flow & Pipeline Management with CRM Integration',
                'Real-Time Portfolio Company Performance Dashboards',
                'LP Investor Portal with Capital Calls & Distributions',
                'Advanced Financial Analytics & Predictive Modeling'
            ]
        },
        overview: {
            title: 'Why Choose Our Private Equity Software Development Company?',
            description: 'We streamline investment operations with custom technology platforms designed for PE firms, venture capital funds, and institutional investors. Our private equity software development services include comprehensive deal sourcing CRM systems, due diligence workflow automation, portfolio management dashboards, fund accounting platforms, investor relations portals, ESG reporting tools, and advanced analytics engines built with enterprise security, bank-level encryption, and seamless integration with Bloomberg Terminal, FactSet, PitchBook, and Salesforce.',
            stats: [
                { value: '60%', label: 'Faster Deal Processing Time' },
                { value: '$15B+', label: 'Assets Under Management (AUM)' },
                { value: '99.9%', label: 'Data Accuracy & Integrity' }
            ]
        },
        services: [
            {
                title: 'Deal Flow & Pipeline Management',
                description: 'Build sophisticated CRM systems for investment opportunity sourcing, deal tracking, evaluation workflows, competitive intelligence gathering, automated investment committee reporting, due diligence checklists, and integration with proprietary deal sourcing databases and industry data providers.',
                icon: 'stream'
            },
            {
                title: 'Portfolio Monitoring & Performance Tracking',
                description: 'Create real-time dashboards aggregating portfolio company financial metrics, operational KPIs, revenue/EBITDA tracking, valuation updates, board meeting management, 100-day plan tracking, strategic initiative monitoring, and automated variance analysis with customizable reporting for partners and LPs.',
                icon: 'tachometer-alt'
            },
            {
                title: 'LP Investor Portal & Fund Administration',
                description: 'Develop secure limited partner portals with quarterly performance reporting, capital call notices, distribution processing, tax document delivery (K-1s), ESG impact reports, meeting minutes distribution, document repository with version control, and integration with DocuSign for electronic signatures.',
                icon: 'columns'
            },
            {
                title: 'Financial Analytics & Predictive Modeling',
                description: 'Build advanced analytics platforms with Python-based financial modeling, Monte Carlo simulations, scenario analysis, IRR/MOIC calculations, cash flow forecasting, market trend analysis, comparable company analysis automation, and AI-powered investment opportunity scoring with integration to Bloomberg, S&P Capital IQ.',
                icon: 'analytics'
            }
        ],
        technologies: {
            title: 'Enterprise PE Technology Stack for 2026',
            items: [
                'React/Angular for responsive web dashboards',
                'Python/R for financial modeling & quantitative analysis',
                'Power BI/Tableau for data visualization & reporting',
                'Salesforce CRM customization & API integration',
                'PostgreSQL/SQL Server for secure data warehousing',
                'Bloomberg Terminal/FactSet/PitchBook API connectivity',
                'Bank-level AES-256 encryption & multi-factor auth',
                'DocuSign/Adobe Sign for electronic document signing'
            ]
        },
        caseStudy: {
            title: 'Success Story: Multi-Fund Private Equity Management Platform',
            description: 'Delivered a comprehensive fund management system for a mid-market PE firm managing $5B AUM across 4 active funds with 25 portfolio companies featuring automated LP reporting, deal pipeline management, portfolio performance tracking, and integrated accounting/tax workflows reducing operational overhead by 65% and enabling 100% paperless fund administration.',
            results: [
                '70% reduction in quarterly reporting time',
                '100% LP investor portal adoption rate',
                '$750K annual operational cost savings'
            ]
        },
        cta: {
            title: 'Optimize Your PE Fund Operations in 2026',
            subtitle: 'Schedule a free consultation to build secure, SOC 2 compliant technology solutions that streamline deal flow, portfolio management, and investor relations.',
            buttonText: 'Get Free PE Software Consultation'
        }
    },
    {
        id: '7',
        title: 'Education Technology',
        slug: 'education',
        icon: sIcon7,
        tagline: 'EdTech Software Development | Learning Management Systems 2026',
        hero: {
            title: 'Custom EdTech Software Development | LMS, Virtual Classrooms & E-Learning Platforms',
            subtitle: 'Transform education delivery with enterprise learning management systems (LMS), virtual classroom platforms, student information systems (SIS), AI-powered personalized learning, and mobile learning apps. WCAG 2.1 AA accessible solutions trusted by 60+ K-12 schools, universities, and corporate training providers.',
            highlights: [
                'Cloud-Based Learning Management Systems with SCORM/xAPI',
                'Live Virtual Classroom Platforms with WebRTC Video',
                'Student Information Systems with Parent/Teacher Portals',
                'AI-Powered Adaptive Learning & Personalized Content'
            ]
        },
        overview: {
            title: 'Why Choose Our EdTech Development Company?',
            description: 'We revolutionize education delivery with modern technology platforms that enhance learning outcomes, increase student engagement, and streamline educational administration. Our EdTech software development services include comprehensive learning management systems, virtual classroom solutions, student information management, online assessment platforms, mobile learning applications, AI-powered tutoring systems, and content management tools built with WCAG accessibility standards, FERPA/GDPR compliance, and seamless integration with existing school information systems.',
            stats: [
                { value: '100K+', label: 'Students Using Our Platforms' },
                { value: '95%', label: 'Student Engagement Rate' },
                { value: '45%', label: 'Improved Learning Outcomes' }
            ]
        },
        services: [
            {
                title: 'Learning Management System (LMS) Development',
                description: 'Build comprehensive LMS platforms with course creation tools, multimedia content delivery, assignment management, automated grading, quiz/assessment builders, gradebook tracking, student progress analytics, discussion forums, certificate generation, and SCORM/xAPI/LTI compliance for interoperability with third-party content.',
                icon: 'chalkboard-teacher'
            },
            {
                title: 'Virtual Classroom & Video Learning',
                description: 'Develop real-time virtual classroom platforms with HD video conferencing (WebRTC), interactive digital whiteboards, screen sharing, breakout room functionality, session recording, live polls/quizzes, hand raising, chat features, attendance tracking, and integration with Zoom, Microsoft Teams, or custom video infrastructure.',
                icon: 'video'
            },
            {
                title: 'Student Information Systems (SIS)',
                description: 'Create complete school management platforms with student enrollment, attendance tracking, grade management, transcript generation, parent/guardian portals, teacher dashboards, class scheduling, behavior tracking, health records, cafeteria management, transportation tracking, and administrative reporting with PowerSchool/Infinite Campus integration.',
                icon: 'window-restore'
            },
            {
                title: 'AI-Powered Personalized Learning',
                description: 'Build adaptive learning platforms with AI-driven content recommendations, learning path customization based on student performance, automated assessment and immediate feedback, skill gap identification, predictive analytics for at-risk student detection, intelligent tutoring systems, and natural language processing for essay grading.',
                icon: 'robot'
            }
        ],
        technologies: {
            title: 'Modern EdTech Development Stack for 2026',
            items: [
                'React/Vue.js for interactive student interfaces',
                'WebRTC/Agora for real-time video conferencing',
                'TensorFlow/PyTorch for AI/ML personalized learning',
                'React Native/Flutter for iOS & Android mobile apps',
                'SCORM/xAPI/LTI standards for content interoperability',
                'AWS/Azure cloud with CDN for video delivery',
                'H5P/Articulate integration for interactive content',
                'WCAG 2.1 AA accessibility & FERPA compliance'
            ]
        },
        caseStudy: {
            title: 'Success Story: K-12 Virtual Learning Platform for 25,000+ Students',
            description: 'Developed a comprehensive cloud-based virtual learning platform serving 25,000 K-12 students across 40 schools with live video classes, digital assignments, automated grading, parent engagement features, attendance tracking, and mobile apps for iOS/Android achieving 99.5% platform uptime during peak remote learning periods.',
            results: [
                '25,000 active students & 1,200 teachers',
                '99.5% platform uptime (99.9% SLA)',
                '88% parent portal engagement rate'
            ]
        },
        cta: {
            title: 'Build the Future of Digital Learning in 2026',
            subtitle: 'Schedule a free consultation to create engaging, accessible EdTech solutions that improve student outcomes and streamline educational administration.',
            buttonText: 'Get Free EdTech Consultation'
        }
    },
    {
        id: '8',
        title: 'FinTech',
        slug: 'finance',
        icon: sIcon8,
        tagline: 'FinTech Software Development | Digital Banking Solutions 2026',
        hero: {
            title: 'Custom FinTech Software Development | Digital Banking & Payment Solutions',
            subtitle: 'Modernize financial services with enterprise digital banking platforms, payment gateway solutions, trading systems, robo-advisory platforms, and regulatory compliance software. PCI DSS Level 1 & SOC 2 Type II compliant solutions trusted by 70+ banks, fintechs, and financial institutions.',
            highlights: [
                'Digital Banking & Neobank Platform Development',
                'Payment Gateway & Processing System Integration',
                'Real-Time Stock/Crypto Trading Platform Development',
                'AI-Powered Robo-Advisory & Wealth Management'
            ]
        },
        overview: {
            title: 'Why Choose Our FinTech Development Company?',
            description: 'We build secure, compliant financial technology solutions that transform banking, payments, lending, and investment services for the digital age. Our fintech software development services include comprehensive digital banking platforms, payment processing systems, peer-to-peer payment apps, lending platforms, trading systems, wealth management applications, InsurTech solutions, and regulatory compliance tools built with enterprise-grade security, PCI DSS compliance, multi-factor authentication, and seamless integration with core banking systems, payment networks (Visa/Mastercard), and financial data providers.',
            stats: [
                { value: '$500M+', label: 'Transaction Volume Processed' },
                { value: '99.99%', label: 'Platform Uptime SLA' },
                { value: '100%', label: 'PCI DSS & SOC 2 Compliant' }
            ]
        },
        services: [
            {
                title: 'Digital Banking & Neobank Development',
                description: 'Build complete digital banking solutions with account opening (KYC/AML), virtual/physical debit cards, ACH/wire transfers, bill payment, mobile check deposit, savings accounts, spending analytics, budgeting tools, real-time notifications, and integration with core banking systems (Temenos, Mambu, Finxact) and card issuers.',
                icon: 'piggy-bank'
            },
            {
                title: 'Payment Processing & Gateway Solutions',
                description: 'Develop custom payment gateways with PCI DSS Level 1 compliance, multi-currency support, tokenization, fraud detection (machine learning), 3D Secure authentication, subscription billing, split payments, instant payouts, QR code payments, and integration with Stripe, PayPal, Adyen, or custom payment rails.',
                icon: 'money-check-alt'
            },
            {
                title: 'Trading Platform & Investment Systems',
                description: 'Create real-time stock, cryptocurrency, forex, and options trading platforms with order management systems (OMS), advanced charting (TradingView), algorithmic trading APIs, market data feeds, portfolio tracking, tax reporting, margin trading, and integration with brokerage APIs (Alpaca, Interactive Brokers, Coinbase Pro).',
                icon: 'line-chart'
            },
            {
                title: 'Robo-Advisory & Wealth Management',
                description: 'Build AI-powered investment platforms with automated portfolio rebalancing, tax-loss harvesting, risk assessment questionnaires, goal-based investing, ETF/mutual fund selection algorithms, performance reporting, financial planning tools, and integration with Plaid for account aggregation and custodians for trade execution.',
                icon: 'briefcase'
            }
        ],
        technologies: {
            title: 'Enterprise FinTech Development Stack for 2026',
            items: [
                'Node.js/Java/Python for high-performance backend',
                'React Native/Flutter for mobile banking apps',
                'PostgreSQL/MongoDB for transaction databases',
                'Plaid/Stripe/Dwolla API integrations',
                'WebSockets for real-time market data streaming',
                'PCI DSS Level 1 & SOC 2 Type II compliance',
                'KYC/AML verification (Jumio, Onfido, Persona)',
                'AWS/Azure with HSM for encryption key management'
            ]
        },
        caseStudy: {
            title: 'Success Story: Multi-Currency Digital Wallet with 200K+ Users',
            description: 'Launched a comprehensive digital wallet platform serving 200,000+ active users with instant P2P transfers, multi-currency support (USD, EUR, GBP, crypto), bill payments, merchant QR code payments, virtual debit cards, and cryptocurrency buy/sell features processing $100M+ monthly transaction volume with 99.99% uptime and zero fraud incidents.',
            results: [
                '200K+ active users across 15 countries',
                '$100M+ monthly transaction volume',
                'Zero security breaches or fraud incidents'
            ]
        },
        cta: {
            title: 'Launch Your FinTech Solution in 2026',
            subtitle: 'Schedule a free consultation to build secure, PCI DSS compliant financial platforms including digital banking, payments, trading, and wealth management solutions.',
            buttonText: 'Get Free FinTech Consultation'
        }
    },
    {
        id: '9',
        title: 'Healthcare Technology',
        slug: 'healthcare',
        icon: sIcon9,
        tagline: 'Healthcare Software Development | Telemedicine & EHR/EMR Solutions 2026',
        hero: {
            title: 'Custom Healthcare Software Development | HIPAA-Compliant Telemedicine & EHR Systems',
            subtitle: 'Transform healthcare delivery with enterprise telemedicine platforms, electronic health records (EHR/EMR) systems, patient portal development, medical AI diagnostics, and healthcare IoT solutions. HIPAA, HITECH & FDA compliant platforms trusted by 90+ hospitals, clinics, and healthcare providers.',
            highlights: [
                'HIPAA-Compliant Telemedicine Platforms with Video Visits',
                'Cloud-Based EHR/EMR Systems with HL7/FHIR Integration',
                'Patient Portal Development with Appointment Scheduling',
                'AI-Powered Medical Diagnostics & Imaging Analysis'
            ]
        },
        overview: {
            title: 'Why Choose Our Healthcare Software Development Company?',
            description: 'We build HIPAA-compliant healthcare technology that improves patient outcomes, streamlines clinical workflows, and reduces operational costs. Our healthtech software development services include comprehensive telemedicine platforms, electronic health record (EHR/EMR) systems, practice management software, patient engagement portals, medical billing systems, clinical decision support tools, remote patient monitoring, and AI-powered diagnostic solutions built with enterprise security, HL7/FHIR interoperability standards, and seamless integration with existing healthcare IT infrastructure.',
            stats: [
                { value: '150K+', label: 'Patient Virtual Encounters' },
                { value: '100%', label: 'HIPAA/HITECH Compliant' },
                { value: '92%', label: 'Patient Satisfaction Rating' }
            ]
        },
        services: [
            {
                title: 'Telemedicine Platform Development',
                description: 'Build complete virtual care solutions with HD video consultations (WebRTC), secure patient-provider messaging, e-prescribing (DrFirst, Surescripts integration), digital intake forms, insurance verification, copay collection, appointment scheduling, waiting room functionality, session recording for compliance, and mobile apps for iOS/Android with push notifications.',
                icon: 'video'
            },
            {
                title: 'EHR/EMR System Development',
                description: 'Create comprehensive electronic health records with patient demographics, clinical documentation (SOAP notes), medication management, allergy tracking, immunization records, lab results integration, radiology imaging (DICOM), problem lists, care plans, clinical workflows, e-prescribing, and HL7/FHIR API for interoperability with Epic, Cerner, AllScripts.',
                icon: 'file-medical'
            },
            {
                title: 'Patient Portal & Engagement Platforms',
                description: 'Develop self-service patient portals with appointment booking, provider search, medical records access, lab/test results viewing, medication lists, prescription refills, secure messaging with providers, bill payment, insurance card storage, family member management, health trackers (vitals, symptoms), and integration with wearables (Apple Health, Fitbit).',
                icon: 'user-injured'
            },
            {
                title: 'Medical AI & Diagnostic Systems',
                description: 'Build AI-powered healthcare solutions with medical imaging analysis (X-ray, MRI, CT scan) using deep learning, predictive analytics for disease risk assessment, clinical decision support systems (CDSS), natural language processing for clinical notes, symptom checkers, drug interaction checking, and real-time patient monitoring with IoT medical devices.',
                icon: 'x-ray'
            }
        ],
        technologies: {
            title: 'HIPAA-Compliant HealthTech Stack for 2026',
            items: [
                'HIPAA-compliant AWS/Azure/GCP cloud hosting',
                'HL7 v2/v3 & FHIR (Fast Healthcare Interoperability Resources)',
                'WebRTC for HIPAA-compliant video telemedicine',
                'TensorFlow/PyTorch for medical AI & diagnostics',
                'Blockchain for secure medical records (patient consent)',
                'IoT device integration (wearables, RPM devices)',
                'AES-256 encryption at rest & TLS 1.3 in transit',
                'Annual HIPAA security audits & penetration testing'
            ]
        },
        caseStudy: {
            title: 'Success Story: Multi-Specialty Telemedicine Platform for 80K+ Patients',
            description: 'Delivered a comprehensive HIPAA-compliant telemedicine solution serving 80,000+ patients across primary care, mental health, and specialty consultations with HD video visits, e-prescriptions, insurance billing integration (claims submission), patient mobile apps, provider scheduling, automated appointment reminders, and integration with existing Epic EHR system reducing in-person visits by 45%.',
            results: [
                '80K+ virtual patient consultations annually',
                '96% patient satisfaction score (CAHPS)',
                '55% reduction in no-show rates with reminders'
            ]
        },
        cta: {
            title: 'Innovate Healthcare Delivery with Technology in 2026',
            subtitle: 'Schedule a free consultation to build HIPAA-compliant healthcare solutions including telemedicine, EHR/EMR, patient portals, and medical AI that improve care quality and operational efficiency.',
            buttonText: 'Get Free HealthTech Consultation'
        }
    },
    {
        id: '10',
        title: 'Automotive Technology',
        slug: 'automotive',
        icon: sIcon10,
        tagline: 'Automotive Software Development | Connected Car Solutions 2026',
        hero: {
            title: 'Custom Automotive Software Development | Fleet Management & Connected Vehicle Platforms',
            subtitle: 'Drive the future of mobility with enterprise fleet management systems, connected car platforms, EV charging network solutions, vehicle marketplace platforms, and automotive IoT integration. Trusted by 45+ fleet operators, automotive OEMs, and mobility service providers.',
            highlights: [
                'Real-Time GPS Fleet Management with Route Optimization',
                'Connected Car Platforms with Telematics & OTA Updates',
                'EV Charging Network Management & Payment Systems',
                'Vehicle Marketplace Development with VIN Verification'
            ]
        },
        overview: {
            title: 'Why Choose Our Automotive Software Development Company?',
            description: 'We transform the automotive industry with connected vehicle technology, IoT integration, and intelligent fleet management systems built for the electric, autonomous, and shared mobility era. Our automotive software development services include comprehensive fleet management platforms, telematics solutions, predictive maintenance systems, EV charging infrastructure software, vehicle-to-everything (V2X) communication, ADAS integration, in-vehicle infotainment systems, and automotive marketplace applications built with real-time data processing, cloud scalability, and seamless integration with vehicle CAN bus systems.',
            stats: [
                { value: '15K+', label: 'Connected Vehicles Managed' },
                { value: '99.2%', label: 'GPS Location Accuracy' },
                { value: '50%', label: 'Fleet Maintenance Cost Reduction' }
            ]
        },
        services: [
            {
                title: 'Fleet Management System Development',
                description: 'Build comprehensive fleet management platforms with real-time GPS tracking, geofencing alerts, route optimization algorithms, driver behavior monitoring (harsh braking, speeding, idling), fuel consumption analytics, maintenance scheduling, compliance reporting (ELD, DVIR, IFTA), dispatch management, and mobile apps for drivers with turn-by-turn navigation and delivery proof.',
                icon: 'car'
            },
            {
                title: 'Connected Car & Telematics Platforms',
                description: 'Develop connected vehicle solutions with OBD-II/CAN bus data collection, remote vehicle diagnostics, over-the-air (OTA) software updates, predictive maintenance alerts, stolen vehicle recovery, usage-based insurance (UBI) integration, in-vehicle infotainment systems, voice assistants, and smartphone app integration for remote lock/unlock, climate control.',
                icon: 'broadcast-tower'
            },
            {
                title: 'EV Charging Network Solutions',
                description: 'Create electric vehicle charging infrastructure platforms with charging station management, mobile apps for station locator and availability, reservation systems, payment processing, RFID/app-based authentication, load balancing, energy management, billing/invoicing, OCPP protocol integration, and network operator dashboards with real-time monitoring.',
                icon: 'charging-station'
            },
            {
                title: 'Vehicle Marketplace Platform Development',
                description: 'Build online automotive marketplaces for buying, selling, renting vehicles with VIN decoder integration, vehicle history reports (Carfax/AutoCheck API), 360° photo galleries, video walkthroughs, advanced search filters, price comparison tools, financing calculators, instant trade-in valuations, seller verification, and integrated payment escrow services.',
                icon: 'search-location'
            }
        ],
        technologies: {
            title: 'Advanced Automotive Technology Stack for 2026',
            items: [
                'IoT sensors & CAN bus telematics integration',
                'Google Maps/HERE/Mapbox real-time GPS & routing',
                'React Native/Flutter for iOS & Android mobile apps',
                'AWS IoT Core/Azure IoT Hub for vehicle data',
                'TensorFlow for predictive maintenance AI models',
                'Blockchain for vehicle history & ownership records',
                'Carfax/AutoCheck/KBB API integrations',
                'Stripe/PayPal for payments & subscription billing'
            ]
        },
        caseStudy: {
            title: 'Success Story: Commercial Fleet Management Platform for 3,500+ Vehicles',
            description: 'Developed a comprehensive cloud-based fleet management system tracking 3,500+ commercial delivery vehicles across North America with real-time GPS tracking, route optimization reducing drive time by 22%, driver safety scoring, automated maintenance schedules, fuel card integration, and comprehensive reporting dashboards achieving $1.8M annual operational cost savings.',
            results: [
                '3,500+ vehicles tracked in real-time',
                '40% reduction in fuel consumption costs',
                '30% decrease in maintenance expenses'
            ]
        },
        cta: {
            title: 'Accelerate Your Automotive Technology Innovation in 2026',
            subtitle: 'Schedule a free consultation to build connected vehicle solutions including fleet management, telematics, EV charging, and automotive marketplace platforms that drive business growth.',
            buttonText: 'Get Free Automotive Tech Consultation'
        }
    }
]

export default Industries;
